import React from 'react';
import { useParams } from 'react-router-dom';
import OnboardingSurvey from 'components/onboarding/onboarding_survey';
import RedirectToHome from 'pages/main/redirect_to_home';

const SURVEY_COMPONENTS = {
  onboarding: OnboardingSurvey,
};

const Survey = () => {
  const {surveySlug} = useParams();
  const SurveyComponent = SURVEY_COMPONENTS[surveySlug];

  return SurveyComponent ? <SurveyComponent /> : <RedirectToHome />;
};

export default Survey;
